import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { phoneNumber } from '~/ui/constants/validation';

const validationSchema = object().shape({
  name: string().max(100, 'Max length - 100 symbols').required('Field is required'),
  specialty: string().nullable().max(100, 'Max length - 100 symbols'),
  phone: phoneNumber,
  fax: phoneNumber,
});

export default yupResolver(validationSchema);
